// Promise-based in-app confirm dialog — replaces window.confirm() app-wide.
// Usage: if (!(await confirmDialog('Cancel this shipment?'))) return;
//   or   await confirmDialog({ title, message, confirmText, cancelText, danger })
let listener = null;

export function confirmDialog(opts) {
  const o = typeof opts === 'string' ? { message: opts } : (opts || {});
  return new Promise((resolve) => {
    if (!listener) { resolve(window.confirm(o.message || 'Are you sure?')); return; } // fallback pre-mount
    listener({ ...o, resolve });
  });
}

export function _registerConfirm(fn) { listener = fn; }
